import getCards from 'app/games/taboo/selectors/getCards';

export default function getCardsByCategory(state, categoryId) {
  return getCards(state).filter(card => card.category === categoryId);
}
